import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import qs from 'qs'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinProceeding = {
  async apiCalendar(arg = { params: { parentActivityId: ' ' } }) {
    // let [err, res] = [null, null]
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Activity/getactivitycalendarlist/${arg.params.parentActivityId}`
      )
    )
    return Callback.globalCB(err, res)
  },
  async apiGantt(arg = { params: { parentActivityId: ' ' } }) {
    // let [err, res] = [null, null]
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Activity/getactivityganttlist/${arg.params.parentActivityId}`)
    )
    return Callback.globalCB(err, res)
  },
  async api5D(arg = { method: 'timing', params: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'model':
        const modelObj = {
          activityId: ' ',
          startTime: ' ',
          finishDate: ' ',
          actualStartDate: ' ',
          actualEndDate: ' ',
        }
        if (arg.params) {
          _.assign(modelObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Activity/GetFiveDSimulationList/${modelObj.activityId}/${modelObj.startTime}/${modelObj.finishDate}/${modelObj.actualStartDate}/${modelObj.actualEndDate}`
            )
          )
        )
        break
      default:
        const obj = {
          activityId: ' ',
        }
        if (arg.params && arg.params.activityId) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(encodeUrl(`/api/Activity/getactivityplantime/${obj.activityId}`))
        )
    }
    return Callback.globalCB(err, res)
  },
  async apiModelTree(arg = { method: 'list', params: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'bind':
        const bindObj = {
          siteId: ' ',
          activityId: ' ',
          activityModelTrees: {},
        }
        if (arg.params && arg.params.siteId) {
          _.assign(bindObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(`/api/Activity/bindmodeltreelist/${bindObj.siteId}/${bindObj.activityId}`),
            bindObj.activityModelTrees
          )
        )
        break
      case 'unbind':
        const unbindObj = {
          siteId: ' ',
          activityId: ' ',
          tagIds: [],
        }
        if (arg.params && arg.params.siteId) {
          _.assign(unbindObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(
              `/api/Activity/unbindmodeltreelist/${unbindObj.siteId}/${unbindObj.activityId}`
            ),
            unbindObj.tagIds
          )
        )
        break
      case 'modelTree':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Document/model_tree', arg.params.modelTree)
        )
        break
      default:
        const obj = {
          siteId: ' ',
          activityId: ' ',
          activityModelTrees: {},
        }
        if (arg.params && arg.params.siteId) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.post(
            encodeUrl(`/api/Activity/getmodeltreelist/${obj.siteId}/${obj.activityId}`),
            obj.activityModelTrees
          )
        )
    }
    return Callback.globalCB(err, res)
  },
  async apiPlans(arg = { method: 'list', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'exportExcel':
        const exportExcelObj = {
          planStartDate: ' ',
          planFinishDate: ' ',
          buildStatus: ' ',
        }
        if (arg.params && arg.params.parentActivityId) {
          _.assign(exportExcelObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Activity/getexceltemplateasync/${exportExcelObj.parentActivityId}/${exportExcelObj.planStartDate}/${exportExcelObj.planFinishDate}/${exportExcelObj.buildStatus}`
            )
          )
        )
        break
      case 'update':
        ;[err, res] = await To(
          wizStandardInstance.patch('/api/Activity/updateactivityplan', arg.params || [])
        )
        break
      case 'setType':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Activity/setactivitytype', arg.params || {})
        )
        break
      case 'getTag':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/activity/query_activity_tag/?${qs.stringify(arg.params)}`)
        )
        break
      case 'selectionTag':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/activity/get_activity_related_tag/?${qs.stringify(arg.params)}`
          )
        )
        break
      case 'selectionTagHy':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/activity/get_activity_related_tag_hy/?${qs.stringify(arg.params)}`
          )
        )
        break
      case 'bindOrUnbind':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/activity/activity_bind_tag', arg.params)
        )
        break
      default:
        const obj = {
          planStartDate: ' ',
          planFinishDate: ' ',
          buildStatus: ' ',
        }
        if (arg.params && arg.params.parentActivityId) {
          _.assign(obj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Activity/getactivityplanlist/${obj.parentActivityId}/${obj.planStartDate}/${obj.planFinishDate}/${obj.buildStatus}`
            )
          )
        )
    }
    return Callback.globalCB(err, res)
  },
  async apiPrName(arg = { params: { activityId: ' ' } }) {
    // let [err, res] = [null, null]
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Activity/getactivityprfilemd5/${arg.params.activityId}`)
    )
    return Callback.globalCB(err, res)
  },
  async apiActivities(arg = { method: 'list', params: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'detail':
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/Activity/getactivitydetail/${arg.params.id}`)
        )
        break
      default:
        ;[err, res] = await To(
          wizStandardInstance.get(`/api/Activity/getprogresscomboxlist/${arg.params.siteId}`)
        )
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async apiProceeding(arg = { method: 'list', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'uploadProjectFile':
        const uploadObj = {
          activityId: '%20',
          isMainActivity: 0,
          isCover: 0,
        }
        if (arg.params) {
          _.assign(uploadObj, arg.params)
        }
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Activity/uploadproject', arg.formData)
        )
        break
      case 'edit':
        ;[err, res] = await To(
          wizStandardInstance.patch('/api/Activity/updateactivityprogress', arg.params)
        )
        break
      case 'delete':
        ;[err, res] = await To(
          wizStandardInstance.post(`/api/Activity/deleteactivityprogress/${arg.params.id}`)
        )
        break
      case 'p6':
        ;[err, res] = await To(wizStandardInstance.get('/api/taskjobmanagement/synchro_p6_store'))
        break
      default:
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              `/api/Activity/getactivityprogresslist/${arg.params.siteId || ' '}/${
                arg.params.activityId !== 0 ? arg.params.activityId : ' '
              }`
            )
          )
        )
    }
    return Callback.globalCB(err, res)
  },
  async apiRelatedFiles(arg = { method: 'list', params: {}, formData: {} }) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'relatedList':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Activity/query_activity_related_files', arg.params)
        )
        break
      case 'saveRelatedFile':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/Activity/task_relation_file', arg.params)
        )
        break
      case 'delete':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/DocumentFile/deleteasync', arg.params)
        )
        break
      case 'baseDelete':
        ;[err, res] = await To(
          wizStandardInstance.delete('/api/basedata/objectassociation', { data: arg.params })
        )
        break
      default:
        console.log('nothing')
    }
    return Callback.globalCB(err, res)
  },
}

export default {
  methods: ApiMixinProceeding,
}
